import { useEffect, useState } from "react";
import "../styles/newsevents.scss"
import Header from "../components/header";
import Footer from "../components/footer"
import MenuTab from "../components/menu_tab";
import Banner from "../components/banner";
import PostItem from "../components/post_item";

import PostItems from "../components/posts/postItems";
import cis from "../assets/imgs/cis.png";
import gatitu from "../assets/imgs/gatitumeeting.jpg";
import pe from "../assets/imgs/publicparticipation.jpeg";
import waterinterruptiongatamaiyu from "../assets/imgs/waterinterruptiongatamaiyu.jpg";
import waterrestoredgatamaiyu from "../assets/imgs/waterrestoredgatamaiyu.jpg";

export default function NewsEvents (props) {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [toggleQuickServices, setToggleQuickServices] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/api/news")
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error("");
      })
      .then((data) => {
        
        setData(data)
      })
      .catch((e) => {});
  }, []);
  
  return (
    <div className="body">
      <Banner />
      <Header toggleMenu={toggleMenu} 
        setToggleMenu={setToggleMenu}
      />
      {toggleMenu && <MenuTab toggleMenu={toggleMenu} 
        setToggleMenu={setToggleMenu}
      />}
      <div className="image2">
        <div id="newconnection">
          <p>News & Events</p>
        </div>
      </div>
      <div className="newsevents" id="newsevents">
        <div className="centerheading">
        <h5  className="decorated-heading">Be on the know...</h5> 
        </div>
        <div className="posts">
          {data && [...data]?.reverse().map((item, index) => {
            return (
              <PostItem 
                key={item.ID} // Optional but recommended for React
                id={item.ID}
                images={item.Images} 
                title={item.Title} 
                details={item.Description} 
                date={item.Date} 
              />
            );
          })} 
        </div>
      </div>
      <Footer />
    </div>
  );
}